export const FIREWIRE_TENANT = "pili-mobile";

export type ITenant =
	| "la-county-fire-dep"
	| "local-119-u"
	| "local-119-dep"
	| "firewire-test-db"
	| "local-858"
	| "local-575"
	| "pili-mobile";
